var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgCoHostSmall = function SvgCoHostSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "Co-host_small_svg__a",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#efefef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9d9d9d"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Polygon 19",
    d: "M5.843.821a2 2 0 012.314 0l4.635 3.288a2 2 0 01.741 2.263l-1.751 5.26A2 2 0 019.884 13H4.116a2 2 0 01-1.9-1.368L.468 6.371a2 2 0 01.741-2.263z",
    fill: "url(#Co-host_small_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon awesome-crown",
    d: "M9.945 9.594H4.056a.227.227 0 00-.227.227v.453a.227.227 0 00.227.227h5.889a.227.227 0 00.225-.227v-.453a.227.227 0 00-.225-.227zm.906-4.53a.68.68 0 00-.68.68.666.666 0 00.062.28l-1.025.614a.452.452 0 01-.626-.164L7.429 4.452a.68.68 0 10-.858 0L5.418 6.474a.453.453 0 01-.626.164L3.77 6.024a.679.679 0 10-.619.4.694.694 0 00.108-.012l1.023 2.729h5.436l1.024-2.729a.694.694 0 00.109.011.68.68 0 100-1.359z",
    fill: "#fff"
  })));
};
export default SvgCoHostSmall;